import React from 'react';
import { SPOILER_TYPE, VIDEO_TYPE } from 'ricos-content';
import { Node_Type } from 'ricos-schema';
import { PLUGIN_TOOLBAR_BUTTON_ID, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { getVisibleOnlyOnDesktopResolver } from 'wix-rich-content-plugin-commons';
import { SizePanel, NodeSizeButton, AlignmentPanel, NodeAlignmentButton } from 'wix-rich-content-toolbars-ui';
import { VIDEO_BUTTONS, videoModals } from './constants.js';
import { InsertModal } from './modals/InsertModal.js';
import { SettingsModal } from './modals/SettingsModal.js';
import '@wix/design-system';
import 'ricos-context';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './embed-video-30a2eb58.js';
import 'wix-react-player';
import './style-inject.es-e7b07dd7.js';
import './dataHooks.js';
import './toolbar/is-video-metadata.js';
import './toolbar/upload-video.js';
import 'ricos-schema/dist/statics/video.defaults.json';
import './types.js';
import './toolbar/videoPluginService.js';
import 'lodash';
import './modals/VideoSettings.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getToolbarButtons = (config, services) => {
  const {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    handleFileSelection,
    handleFileUpload,
    onVideoSelected
  } = config || {};
  const {
    modals,
    context: { isMobile }
  } = services;
  const modalBaseProps = {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    handleFileSelection,
    handleFileUpload,
    onVideoSelected
  };
  const shouldShowSpoiler = () => {
    const spoilerPlugin = services.plugins.asArray().find((plugin) => plugin.getType() === SPOILER_TYPE);
    return spoilerPlugin && (!spoilerPlugin.getConfig().supportedPlugins || spoilerPlugin.getConfig().supportedPlugins.includes(VIDEO_TYPE));
  };
  const settingsVisibilityResolver = {
    id: "IS_VIDEO_SETTINGS_BUTTON_VISIBLE",
    resolve: (content) => {
      var _a, _b, _c, _d;
      if (Array.isArray(content) && content.length > 0) {
        const isCustomVideo = !!((_d = (_c = (_b = (_a = content.find((node) => {
          var _a2;
          return ((_a2 = node == null ? void 0 : node.type) == null ? void 0 : _a2.name) === Node_Type.VIDEO;
        })) == null ? void 0 : _a.attrs) == null ? void 0 : _b.video) == null ? void 0 : _c.src) == null ? void 0 : _d.id);
        return shouldShowSpoiler() || isCustomVideo;
      }
      return false;
    }
  };
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT", "FULL_WIDTH"]
        }),
        id: VIDEO_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: VIDEO_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: VIDEO_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: VIDEO_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SETTINGS,
      modal: {
        id: videoModals.settings,
        Component: SettingsModal
      },
      attributes: {
        visible: settingsVisibilityResolver
      },
      command: ({ isMobile: isMobile2, attributes: { selectedNode } }) => {
        modals == null ? void 0 : modals.openModal(videoModals.settings, {
          componentProps: {
            nodeId: selectedNode.attrs.id
          },
          positioning: { placement: "right" },
          layout: isMobile2 ? "fullscreen" : "drawer"
        });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: settingsVisibilityResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: decorateComponentWithProps(InsertModal, { modalId: videoModals.replace }),
        id: videoModals.replace
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const {
          video: { src },
          id
        } = selectedNode.attrs;
        const videoSrc = src.url ? { url: src.url } : src.id ? { id: src.id } : {};
        if (modals == null ? void 0 : modals.isModalOpen(videoModals.replace)) {
          modals.closeModal(videoModals.replace);
        } else {
          modals == null ? void 0 : modals.openModal(videoModals.replace, {
            componentProps: __spreadValues({
              componentData: { video: { src: videoSrc } },
              nodeId: id
            }, modalBaseProps),
            positioning: { placement: "bottom", referenceElement },
            layout: isMobile2 ? "fullscreen" : "popover",
            noPadding: true
          });
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
